module.exports = __webpack_public_path__ + "static/img/formation-flying.f9c5dbc.png";